import { render, staticRenderFns } from "./Loanables.vue?vue&type=template&id=07173e8c&scoped=true&"
import script from "./Loanables.vue?vue&type=script&lang=js&"
export * from "./Loanables.vue?vue&type=script&lang=js&"
import style0 from "./Loanables.vue?vue&type=style&index=0&id=07173e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07173e8c",
  null
  
)

export default component.exports